import { render, staticRenderFns } from "./OSelect.vue?vue&type=template&id=1b36f4d7&scoped=true&"
import script from "./OSelect.vue?vue&type=script&lang=js&"
export * from "./OSelect.vue?vue&type=script&lang=js&"
import style0 from "./OSelect.vue?vue&type=style&index=0&lang=postcss&"
import style1 from "./OSelect.vue?vue&type=style&index=1&id=1b36f4d7&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b36f4d7",
  null
  
)

export default component.exports